<template>
  <div :class="parentClasses">
    <AppLabel v-if="hasLabel" :mode="mode" :title="title" />
    <div
      class="relative flex items-center"
      :class="[isDisabled ? 'pointer-events-none opacity-50' : '']"
    >
      <select
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
        class="form-control appearance-none"
        :class="[mode === 'dark' ? 'dark-form-control' : '']"
      >
        <slot name="options" />
      </select>
      <span class="pointer-events-none absolute right-4">
        <ChevronDown :size="20" :stroke-width="1.75" />
      </span>
    </div>
  </div>
</template>

<script>
import { ChevronDown } from "lucide-vue-next";
import AppLabel from "@C/Form/AppLabel.vue";

export default {
  name: "Select",
  props: {
    mode: String,
    modelValue: [String, Number],
    isDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    parentClasses: {
      type: String,
      default: "w-full",
    },
    hasLabel: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ChevronDown,
    AppLabel,
  },
};
</script>
